import * as React from 'react';
import type { SVGIconProps } from './Icon.types';

const CheckIcon = React.forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', filled, ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="14"
        ref={forwardedRef}
        role="img"
        viewBox="0 0 14 14"
        width="14"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <title>{props.title}</title>
        <path
          clipRule="evenodd"
          d="M12.2071 4.35355L5.5 11.0607L1.79289 7.35355L3.20711 5.93934L5.5 8.23223L10.7929 2.93934L12.2071 4.35355Z"
          fill={color}
          fillRule="evenodd"
        />
      </svg>
    );
  },
);

export default CheckIcon;
